/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import * as AppPropTypes from '../../lib/PropTypes';
import * as LogoComponents from '../icons/socials';

import styles from '../../../styles/partials/socials.scss';

const propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        component: PropTypes.string,
        label: PropTypes.string,
        url: PropTypes.string,
    })),
    className: PropTypes.string,
};

const defaultProps = {
    items: [
        {
            component: 'Facebook',
            label: 'Facebook',
            url: 'https://facebook.com/findingsallydoc'
        },
        {
            component: 'Twitter',
            label: 'Twitter',
            url: 'https://twitter.com/findingsallydoc'
        },
        {
            component: 'Instagram',
            label: 'Instagram',
            url: 'https://instagram.com/findingsally_doc'
        },
        {
            component: 'YouTube',
            label: 'YouTube',
            url: 'https://www.youtube.com/channel/UCxlDTCUoIXBnjg_nNCanwSQ'
        },
    ],
    className: null,
};

const Socials = ({ items, className }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        <div className={styles.inner}>
            <h4 className={styles.title}>Follow us</h4>
            <ul className={styles.items}>
                {items.map(({ label, component, url }) => {
                    const LogoComponent = LogoComponents[component] || null;
                    return LogoComponent !== null ? (
                        <li key={`social-${label}`} className={styles.item}>
                            <a href={url} title={label} target="_blank" className={styles.link}>
                                <LogoComponent className={styles.logo} />
                            </a>
                        </li>
                    ) : null;
                })}
            </ul>
        </div>
    </div>
);

Socials.propTypes = propTypes;
Socials.defaultProps = defaultProps;

export default Socials;
